import * as h2Api from '../../h2Api'
import { appendSearchResults, initSearchResults } from '../search'

export const WIP_RESULTS = 'WIP_RESULTS'
export const ADD_WIP_RESULTS = 'ADD_WIP_RESULTS'

export const loadWipResults = filters => dispatch => {
  return dispatch(
    h2Api.post(`/assessment/wip/results`, { filters })({ type: WIP_RESULTS })
  ).then(v => {
    console.log(v)
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentWipResults = filters => (startIdx, endIdx) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/assessment/wip/results`, updatedJson)({ type: ADD_WIP_RESULTS })
  ).then(v => {
    dispatch(appendSearchResults(v.results))
  })
}
